import { Toast } from "./Swal";

window.addEventListener("online", () => {
  Toast.fire({
    icon: "info",
    title: "Conexão restabelecida!",
  });
});

window.addEventListener("offline", () => {
  Toast.fire({
    icon: "error",
    title: "Você está desconectado!",
  });
});

